import { Container, Typography } from "@mui/material";
import React from "react";

const Dashboard = () => {
  return <Container><Typography variant="h3">Dashboard</Typography></Container>;
};

export default Dashboard;
